
export class ReportProfileUsualCountriesModel {
  countryCode: string;
  expiration: Date|null;
}
